import 'svgxuse';
import Layzr from 'layzr.js';
// import zenscroll from './vendor/zenscroll';
import './polyfills';

// Components
import BackToTop from './components/back-to-top';
import IframeLoader from './components/iframe-loader';
import PerformanceModal from './components/performance-modal';
import connectSection from './components/connect-section';
import Quotes from './components/quotes';
import caseStudy from './components/case-study';
import Tabs from './components/tabs';
import Heatmap from './components/heatmap';
import Header from './components/header';
import VideoModal from './components/video-modal';
import DrawerSlide from './components/drawer-slide';

// Utilities
import { instantiate } from './utilities/components';

const classMap = {
  'back-to-top': BackToTop,
  'iframe-loader': IframeLoader,
  'performance-modal': PerformanceModal,
  'connect-section': connectSection,
  tabs: Tabs,
  caseStudy,
  quotes: Quotes,
  heatmap: Heatmap,
  header: Header,
  videoModal: VideoModal,
  'drawer-slide': DrawerSlide,
};

// // Initialize zenscroll and change threshold option to
// // account for sticky nav
// const edgeOffset = 110;
// zenscroll.setup(null, edgeOffset);

// Lazy Load any images
export const lazyLoad = Layzr({
  threshold: 60,
});

// Event handler functions
function handleDOMContentLoaded() {
  // Call component constructors
  instantiate(classMap);

  // Run lazyload functions to update, check, and attach any event handlers
  lazyLoad.update().check().handlers(true);

  // Grab analytics event tracking elements
  const firedElements = document.querySelectorAll('.fire-analytics');

  // Loop elements and grab attribute values, fire events
  if (firedElements) {
    Array.from(firedElements).forEach(firedElement => {
      // Grab data attributes for variables
      const elementCategory = firedElement.getAttribute('data-ga-category');
      const elementAction = firedElement.getAttribute('data-ga-action');
      const elementLabel = firedElement.getAttribute('data-ga-label');
      if (elementCategory, elementAction, elementLabel) {
        firedElement.addEventListener('click', () => {
          ga('send', 'event', elementCategory, elementAction, elementLabel);
          dataLayer.push({
            event: 'skylightOffersEvents',
            eventCategory: elementCategory,
            eventAction: elementAction,
            eventLabel: elementLabel,
          });
        });
      }
    });
  }
}

// Add event listeners
document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
